
import React, { Component } from 'react';
import {Col, Row, Button } from 'react-bootstrap';
import {Link} from 'react-router';
import {   USER_LOGOUT} from "actions/actionTypes";
import config from  '../../config';
import {connect} from 'react-redux';
 class Footer extends Component {
     static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

     logoutUser(){
         if (this.props.userReducer.token) {
              this.props.dispatchAction({}, USER_LOGOUT)
             this.context.router.push('/login');
          }
    }


    render() {
       console.log('footer config.applicationVersion',   config.applicationVersion  );
         return (
            <div className="site-footer">
                <div className="text-center">
                    <ul className="site-footer__linklist">
                        {/*<li className="site-footer__linklist-item"   href="#">About us</li>*/}
                        {/*<li className="site-footer__linklist-item"   href="#">Blog</li>*/}
                        {/*<li className="site-footer__linklist-item"  href="#">Terms of Service</li>*/}
                        {/*<li className="site-footer__linklist-item"  href="#">Privacy policy</li>*/}

                        {this.props.userReducer.token &&
                        <Button bsStyle="link" className="site-footer__linklist-item">
                            <Link className="font-size-16" onClick={ this.logoutUser.bind(this) }
                            >{  'Log out' }</Link></Button>
                        }
                     </ul>
                </div>
                <ul className="list--inline site-footer__social-images social-images text-center">
                    <li><a className="social-images__link --facebook-link" href="https://www.facebook.com/goodbuygear" title="GoodBuy Gear on Facebook">
                         <span className="visually-hidden fallback-text">Facebook</span>

                    </a></li>
                    <li>
                        <a className="social-images__link --twitter-link" href="https://twitter.com/goodbuygear" title="GoodBuy Gear on Twitter">
                             <span className="visually-hidden fallback-text">Twitter</span>
                        </a>
                    </li>
                    <li>
                        <a className="social-images__link --vimeo-link" href="https://vimeo.com/kidgear" title="GoodBuy Gear on Vimeo">
                             <span className="visually-hidden fallback-text">Vimeo</span>
                        </a>
                    </li>                </ul>
              <div className="top30 text-center">{`Version ${config.applicationVersion}`}</div>
                <div className="site-footer__copyright-content text-center">© 2017, GoodBuy Gear</div>
                <div className="site-footer__payment-images">

                    <ul className="payment-images list--inline text-center">
                        <li className="payment-image amazon-payment">
                        </li>
                        <li className="payment-image american-express-payment">
                        </li>
                        <li className="payment-image apple-pay-payment">
                        </li>
                        <li className="payment-image master-payment">
                        </li>
                        <li className="payment-image paypal-payment">
                        </li>
                        <li className="payment-image visa-payment">
                        </li>

                    </ul>

                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return { userReducer: state.userReducer }
}

export default connect(mapStateToProps, {   })(Footer);
